export const visa = '/images/vector-payment-methods/visa.svg'
export const mastercard = '/images/vector-payment-methods/mastercard.svg'
export const paypal = '/images/vector-payment-methods/paypal.svg'
export const sepa = '/images/vector-payment-methods/sepa.svg'
export const barzahlen = '/images/vector-payment-methods/barzahlen.svg'
